import { forwardRef } from 'react';
import { MenuItem } from '@material-ui/core';
import cx from 'classnames';
import { startsWith } from 'lodash';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  className: '',
};

export const BaseMenuItem = forwardRef(
  ({ className, item, onClick, children, ...restProps }, ref) => {
    const styles = useStyles();

    const disabled = startsWith(item?.id, 'disabled');

    const handleClick = (event) => {
      event.stopPropagation();
      if (item.emptyState || item.title || disabled) {
        return;
      }

      onClick();
    };

    return (
      <MenuItem
        className={cx(styles.root, className, {
          [styles.disabled]: disabled,
          [styles.emptyState]: item.emptyState,
          [styles.title]: item.title,
        })}
        ref={ref}
        onClick={handleClick}
        {...restProps}
      >
        {children}
      </MenuItem>
    );
  }
);

BaseMenuItem.propTypes = propTypes;
BaseMenuItem.defaultProps = defaultProps;
